import { baseService } from './baseService'
import Response from '../data/entity/response_entity'

import { STATUS_CODE } from '../data/system_settings'
import { PAGE_SIZE } from '../data/queryFactories'
import { showErrorToast } from '../utils/showToast'

export class BookService extends baseService {
  async getByUuid(uuid) {
    if (typeof uuid !== 'string') {
      return Response({
        success: false,
        message: {
          content: 'Kiểu dữ liệu không hợp lệ vui lòng liên hệ Admin',
        },
      })
    }

    try {
      const res = await this.get(`book/${uuid}`)

      return Response({
        success: true,
        message: {
          content: res.data.data,
        },
      })
    } catch (error) {
      handleError(error)
    }
  }

  async search(payloads) {
    const payload = {
      pageSize: payloads?.pageSize ?? PAGE_SIZE,
      pageNumber: payloads?.pageNumber ?? 0,
      keywords: payloads?.keywords,
      createdAt: payloads?.createdAt ?? undefined,
      bookCollectionUuid: payloads?.book_collection_uuid ?? '',
    }
    try {
      const res = await this.post('book/search', payload)
      if (res.status === STATUS_CODE.SUCCESS) {
        return Response({
          success: true,
          message: {
            content: res.data.data,
          },
        })
      } else {
        return Response({
          success: false,
          message: {
            content: 'Vui lòng liên hệ admin',
          },
        })
      }
    } catch (error) {
      return handleError(error)
    }
  }

  async create({ payload, pdf, cover }) {
    try {
      const res = await this.post('book', payload)
      const returnData = res.data.data
      if (res.status === STATUS_CODE.SUCCESS) {
        const pdfUrl = returnData.pdfUploadUrl
        const coverUrl = returnData.coverUploadUrl

        if (cover) {
          const coverRes = await this.uploadFile(coverUrl, cover)
          if (coverRes.status !== STATUS_CODE.SUCCESS) {
            return Response({
              success: false,
              message: {
                content: 'Lỗi khi tải ảnh bìa.',
              },
            })
          }
        }

        const pdfRes = await this.uploadFile(pdfUrl, pdf)
        if (pdfRes.status !== STATUS_CODE.SUCCESS) {
          return Response({
            success: false,
            message: {
              content: 'Lỗi khi tải file pdf.',
            },
          })
        }

        return Response({
          success: true,
          message: {
            content: 'Lưu dữ liệu thành công',
          },
          data: returnData,
        })
      } else {
        return Response({
          success: false,
          message: {
            content: 'Tạo sách thất bại',
          },
        })
      }
    } catch (error) {
      return handleError(error)
    }
  }
  async update({ uuid, payload }) {
    try {
      const res = await this.put(`book/${uuid}`, payload)
      if (res.status === STATUS_CODE.SUCCESS) {
        return Response({
          success: true,
          message: {
            content: 'Lưu dữ liệu thành công',
          },
          data: res.data.data,
        })
      } else {
        return Response({
          success: false,
          message: {
            content: 'Cập nhật sách thất bại',
          },
        })
      }
    } catch (error) {
      return handleError(error)
    }
  }

  async validatePdfExists(bookUuid) {
    if (!bookUuid) {
      return Response({
        success: false,
        message: {
          content: 'UUID của sách là bắt buộc',
        },
      })
    }

    try {
      const res = await this.post(`book/pdf/confirm?book_uuid=${bookUuid}`)
      if (res.status === STATUS_CODE.SUCCESS) {
        return Response({
          success: true,
          message: {
            content: 'PDF tồn tại',
          },
          data: res.data.data,
        })
      } else {
        return Response({
          success: false,
          message: {
            content: 'PDF không tồn tại',
          },
        })
      }
    } catch (error) {
      return handleError(error)
    }
  }

  async validateCoverExists(bookUuid) {
    if (!bookUuid) {
      return Response({
        success: false,
        message: {
          content: 'UUID của sách là bắt buộc',
        },
      })
    }

    try {
      const res = await this.post(`book/cover/confirm?book_uuid=${bookUuid}`)
      if (res.status === STATUS_CODE.SUCCESS) {
        return Response({
          success: true,
          message: {
            content: 'Cover tồn tại',
          },
          data: res.data.data,
        })
      } else {
        return Response({
          success: false,
          message: {
            content: 'Cover không tồn tại',
          },
        })
      }
    } catch (error) {
      return handleError(error)
    }
  }

  async assignCollections({ book, collections }) {
    if (!book || !collections || !Array.isArray(collections)) {
      return Response({
        success: false,
        message: {
          content: 'UUID của sách và mảng collections là bắt buộc',
        },
      })
    }

    try {
      const res = await this.post('book/assign-collections', {
        book,
        collections,
      })
      if (res.status === STATUS_CODE.SUCCESS) {
        return Response({
          success: true,
          message: {
            content: 'Gói sách đã được gán thành công',
          },
          data: res.data.data,
        })
      } else {
        return Response({
          success: false,
          message: {
            content: 'Gán gói sách thất bại',
          },
        })
      }
    } catch (error) {
      return handleError(error)
    }
  }
  // async getAllBookCollection(uuid) {
  //   try {
  //     const res = await this.get(`book-collection/${uuid}`)
  //     if (res.status === STATUS_CODE.SUCCESS) {
  //       return Response({
  //         success: true,
  //         message: {
  //           content: 'Lấy danh sách sách trong gói sách thành công',
  //         },
  //         data: res.data.data,
  //       })
  //     } else {
  //       return Response({
  //         success: false,
  //         message: {
  //           content: 'Lấy sách trong gói sách thất bại',
  //         },
  //       })
  //     }
  //   } catch (error) {
  //     return handleError(error)
  //   }
  // }
  async removeBookfromBookCollection(payload) {
    try {
      const res = await this.deleteWithBody(
        'book-collection/remove-book',
        payload
      )
      if (res.status === STATUS_CODE.SUCCESS) {
        return Response({
          success: true,
          message: {
            content: 'Sách đã được  xóa khỏi gói sách',
          },
          data: res.data.data,
        })
      } else {
        return Response({
          success: false,
          message: {
            content: 'Xóa sách khỏi gói sách thất bại ',
          },
        })
      }
    } catch (error) {
      return this.handleError(error)
    }
  }
}

const handleError = (error) => {
  let message = error.message || 'Lỗi không xác định'
  if (error.response) {
    const { status, data } = error.response
    message = data.error || 'Lỗi không xác định'
    if (status === STATUS_CODE.BAD_REQUEST) {
      message = 'Vui lòng kiểm tra lại đầu vào'
    } else if (status === STATUS_CODE.FORBIDDEN) {
      message = 'Bạn không có quyền truy cập'
    } else if (status === STATUS_CODE.NOT_FOUND) {
      message = 'Không tìm thấy thông tin'
    } else if (status === STATUS_CODE.SERVER_ERROR) {
      message = 'Mất kết nối với máy chủ, hãy thử lại'
    }
  }
  return Response({ success: false, message: { content: message } })
}
export const bookService = new BookService()
